module.exports = __webpack_public_path__ + "media/images/shared/suppliers/BEHRHELLA-d1b9ee392b0c4d471e7960604431a444.jpg";